import axios from "axios";
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ElMessage } from "element-plus";
import { Storage } from '@/utils/storage/index';
import { login } from "@/api";
// import { useUserStore } from "@/store";
// console.log(useUserStore)
// const userStore = useUserStore();

let requestQueue = [];
let baseUrl = '';

// const env = process.env
// console.log(env)
// if (env.NODE_ENV == 'development') {
//     baseUrl = `http://192.168.110.27:8000/`; // 开发环境地址
// } else if (env.NODE_ENV == 'production') {
//     baseUrl = ``; //生产环境地址
// } else if (env.NODE_ENV == 'test') {
//     baseUrl = ``; //测试环境地址
// }

// 创建请求实例
const instance = axios.create({
  //baseURL: "http://192.168.1.100:8008",
  // baseURL: "http://192.168.1.103:8008",
  baseURL: "/api",
  // baseURL:"http://localhost:5502/",
  // baseURL: "http://172.16.0.141:8008/",
  // http://192.168.3.240:8008/
  // 指定请求超时的毫秒数
  timeout: 20000,
  // 表示跨域请求时是否需要使用凭证
  withCredentials: false,
});

// 前置拦截器（发起请求之前的拦截）
instance.interceptors.request.use(
  (config) => {
    /**
     * 在这里一般会携带前台的参数发送给后台，比如下面这段代码：
     * const token = getToken()
     * if (token) {
     *  config.headers.token = token
     * }
     */
    const storage = Storage.getInstance();
    const userInfo = storage.get('USER_INFO')?.value ?? '';
    const { accessToken } = userInfo;

    config.headers['blade-auth'] = accessToken ? `bearer ${accessToken}` : "";
    config.headers['Authorization'] = 'Basic c2FiZXI6c2FiZXJfc2VjcmV0';
    config.headers['Tenant-Id'] = '000000';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 后置拦截器（获取到响应时的拦截）
instance.interceptors.response.use(
  async (response) => {
    /**
     * 根据你的项目实际情况来对 response 和 error 做处理
     * 这里对 response 和 error 不做任何处理，直接返回
     */
    if (response.data.code === 401) {
      // console.log(response)
      // console.log(requestQueue)
      // const storage = Storage.getInstance();
      // const userInfo = storage.get('USER_INFO')?.value ?? '';
      // const { refreshToken } = userInfo;
      // // if(userInfo)
      // login({
      //   grantType: 'refresh_token',
      //   refreshToken: refreshToken,
      // }).then(res => {
      //   storage.set('USER_INFO', res.data)
      //   requestQueue.forEach(item=>{
      //     if(response.request.responseURL.indexOf(item.url)>0){
      //       item.then(res=>{
      //         console.log(res)
      //       })
   
      //     }
      //   })
      // })
      ElMessage.success({
        // message: response.data.msg,
        message: '正在前往登录页面...',
        // showClose: true,
        onClose: () => {
          const storage = Storage.getInstance();
          storage.remove('USER_INFO');
          window.location.replace(`${window.location.origin}`+ window.proxy_path +`/#/login`)
        }
      });
      return Promise.reject(response.data);
    }
    return response.data;
  },
  (error) => {
    const { response, code } = error;
    // console.log(response, code)
    // if (code === "ECONNABORTED") {
    //   ElMessage.error("请求超时！");
    // }
    if (response.data.code !== 200) {
      ElMessage.error({ message: response.data.msg });
    }
    if (response && response.data) {
      return Promise.reject(error);
    }
    const { message } = error;
    // console.error(message);
    return Promise.reject(error);
  }
);

// 导出常用函数

/**
 * @param {string} url
 * @param {object} data
 * @param {object} params
 */
export const post = (url, data = {}, params = {}, headers = {}, responseType: AxiosRequestConfig['responseType'] = 'json',) => {
  let requestPromise = instance({
    method: "post",
    url,
    data,
    params,
    headers,
    responseType: responseType
  });
  requestPromise['url']=url;
  requestQueue.push(requestPromise);
  return requestPromise
};

/**
 * @param {string} url
 * @param {object} params
 */
export const get = (url, params = {}) => {
  let requestPromise = instance({
    method: "get",
    url,
    params,
  });
  requestPromise['url']=url;

  requestQueue.push(requestPromise);
  return requestPromise
};

/**
 * @param {string} url
 * @param {object} data
 * @param {object} params
 */
export const put = (url, data = {}, params = {}) => {
  let requestPromise = instance({
    method: "put",
    url,
    params,
    data,
  });
  requestPromise['url']=url;
  requestQueue.push(requestPromise);

  return requestPromise
};

/**
 * @param {string} url
 * @param {object} params
 */
export const _delete = (url, params = {}) => {
  let requestPromise = instance({
    method: "delete",
    url,
    params,
  });
  requestPromise['url']=url;
  requestQueue.push(requestPromise);
  return requestPromise
};

export default instance;
